<mat-card *ngIf="type === 'register'">
    <h2>Vielen Dank für Ihre Registrierung!</h2>
    <br>
    <p>
        Wir haben eine E-Mail mit einem Aktivierungs-Code an
    </p>
    <p>
        <a href="mailto:{{email}}">{{email}}</a>
    </p>

    <p>
        gesendet. <br><br>
        Bitte folgen Sie den Anweisungen zur Aktivierung Ihres Zugangs und schließen Sie die Registierung ab.
    </p>
</mat-card>

<mat-card *ngIf="type === 'ACTIVATION'">
    <h2>Herzlich Willkommen!</h2>
    <br>
    <p>
        Sie haben Ihren Zugang erfolgreich aktiviert.
    </p>
    <p>
        <button mat-stroked-button color="accent" routerLink="/">Jetzt anmelden</button>
    </p>
</mat-card>

<mat-card *ngIf="type === 'LOST_PW'">
    <h2>Neues Passwort vergeben!</h2>
    <br>
    <p>
        Sie haben Ihr Passwort erfolgreich neu vergeben.
    </p>
    <p>
        <button mat-stroked-button color="accent" routerLink="/">Zur Anmeldung</button>
    </p>
</mat-card>

<mat-card *ngIf="type === 'PW_REQUEST'">
    <h2>Neues Passwort angefordert</h2>
    <br>
    <p>
        Wir haben eine E-Mail mit einem Freigabe-Code an
    </p>
    <p>
        <a href="mailto:{{email}}">{{email}}</a>
    </p>

    <p>
        gesendet. <br><br>
        Bitte folgen Sie den Anweisungen zur Vergabe eines neuen Passwortes.
    </p>
    <p>
        <button mat-stroked-button *ngIf="returnType === 'SIGN_IN'" color="accent" routerLink="/">Zur Anmeldung</button>
        <button mat-stroked-button *ngIf="returnType === 'WELCOME'" color="accent" routerLink="/">Zur
            Startseite</button>
    </p>
</mat-card>


<mat-card *ngIf="type === 'EMAIL_REQUEST'">
    <h2>Neue E-Mail-Adresse</h2>
    <br>
    <p>
        Wir haben eine E-Mail mit einem Validierungs-Code an
    </p>
    <p>
        <a href="mailto:{{email}}">{{email}}</a>
    </p>

    <p>
        gesendet. <br><br>
        Bitte folgen Sie den Anweisungen zur validierung Ihrer neuen E-Mail-Adresse.
    </p>
    <p>
        <button mat-stroked-button color="accent" routerLink="/">Zur Startseite</button>
    </p>
</mat-card>


<mat-card *ngIf="type === 'NEW_EMAIL'">
    <h2>E-Mail-Adresse validiert!</h2>
    <br>
    <p>
        Ihr E-Mal-Adresse wurde erfolgreich validiert und die E-Mail-Änderung somit abgeschlossen.
    </p>
    <p>
        <button mat-stroked-button color="accent" routerLink="/">Zur Startseite</button>
    </p>
</mat-card>